import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import React, { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { PopupModal } from '../../submodule';
import { ReportForm } from '../report/ReportForm';
import { useHistory } from 'react-router-dom';
// import { useStoreState } from 'easy-peasy';
const useStyles = makeStyles((theme) => ({
  container: {
    padding: '50px 20px',
    overflow: 'hidden',
    position: 'relative',
  },
  leftMargin: {
    marginLeft: 10,
  },
  backArrow: {
    position: 'relative',
    top: 7,    
  },
}));
export const ReportDetails = ({ data }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  // const loggedInUserInfo = useStoreState((state) => state.login.userInfo);
  if(!data?.title) return null;
  
  const history = useHistory();
  return (
    <Grid container className={classes.container}>
      <Grid item sm={10}>
        <Typography variant="h4">
          {data.title} - {data.version}
          <Tooltip title="Edit Report" className={classes.leftMargin}>
            <IconButton
              color="primary"
              aria-label="Edit Report"
              onClick={() => {setIsOpen(true)}}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Typography>
      </Grid>
      <Grid item sm={2} style={{textAlign: 'right'}}>
        <Typography style={{cursor: 'pointer', fontSize: '14px'}} variant="h6" component="h6" onClick={() => history.push('/reports/custom') }>
          <KeyboardBackspaceIcon className={classes.backArrow} /> Back to List
        </Typography>
      </Grid>
      
      <Grid item sm={6} style={{wordBreak:'break-word'}}>
        Description: {data.description}
      </Grid>
      <Grid item sm={2}>
        <FormControl component="fieldset">
          <FormGroup>
            <FormControlLabel
              data-testid="current_status_lable"
              control={
                <Switch
                  color="primary"
                  name="is_public"
                  data-testid="is_public"
                  checked={data.is_public == 'n' ? false : true}
                />
              }
              label={data.is_public != 'n' ? "Public":'Private'}
              className="switchLabel"
            />
          </FormGroup>
        </FormControl>
      </Grid>
      <PopupModal open={isOpen} maxWidth="sm">
        <ReportForm type="Edit" data={data} closePopup={()=>setIsOpen(false)}/>
      </PopupModal>
    </Grid>
  );
};
